<form class="asset-category-type-selection-component" [formGroup]="formGroup">
  <mat-form-field>
    <mat-label>Asset type</mat-label>
    <mat-select [formControl]="formControl" placeholder="Select sector..." [compareWith]="compareWithFn" [disableControl]="disabled">
      @for (assetCategoryType of assetCategoryTypes; track assetCategoryType) {
        <mat-option [value]="assetCategoryType">
          {{assetCategoryType.value}}
        </mat-option>
      }
    </mat-select>
    @for (errorKey of errorKeys(formControl); track errorKey) {
      <mat-error>
        @if (formControl.touched && formControl.hasError(errorKey)) {
          {{errorMessage(formControl, errorKey)}}
        }
      </mat-error>
    }
  </mat-form-field>
</form>
